import React from 'react';
import { StyleSheet, Text, TouchableHighlight, View } from '../base_components';

type Props = {
  style?: any;
  className?: string;
  children?: any;
  text?: string;
  href?: any;
  url?: string;
  onPress?: () => void;
  target?: any;
  underlayColor?: any;
};
export default function InlineTextButton(props: Props) {
  const { children, text, onPress, underlayColor, ...other } = props;
  return (
    <Text {...other}>
      {children ?? text}
      <TouchableHighlight
        style={StyleSheet.absoluteFill}
        onPress={onPress}
        underlayColor={underlayColor}
      >
        <View style={StyleSheet.absoluteFill} />
      </TouchableHighlight>
    </Text>
  );
}
